import { useController } from 'react-hook-form';

export const useStepFourForLandscapes = (control) => {
    // const { field: walletReceiveField } = useController({
    //     name: 'walletReceive',
    //     control,
    //     rules: {
    //         required: 'Please enter a wallet address',
    //     },
    // });

    const { field: fundingRequiredByField } = useController({
        name: 'fundingRequiredBy',
        control,
        rules: {
            required: 'Please enter a date',
            validate: (value) => {
                const selectedDate = new Date(value);
                const now = new Date();
                const minTime = new Date(now.getTime() + 10 * 60 * 1000); // 10 minutes from now
                const maxTime = new Date(now.setMonth(now.getMonth() + 2)); // 2 months from now

                console.log(now, minTime, maxTime, 'do greenpill');
                if (selectedDate < minTime) {
                    return 'Please select a time at least 10 minutes from now';
                }

                if (selectedDate > maxTime) {
                    return 'Please select a time within the next 2 months';
                }

                return true;
            },
        },
    });

    return { fundingRequiredByField };
};

// rules: {
//     required: withRewardTokenField?.value ? 'Please enter a date' : false,
// },
